import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useState } from 'react'
import Spinner from '../Spinner'
import { CUSTOMER_PATH, getPageCustomers } from '../../api/customerApi'
import { useApiProgress } from '../../hooks/ApiProgress'
import useFirstRender from '../../hooks/FirstRender'
import CustomerPicker from '../customer/CustomerPicker'
import Input from '../Input'
import { onChange } from '../../utils/functions'
import CurrencyPicker from '../currency/CurrencyPicker'
import { CURRENCIES } from '../../utils/constants'

const ChequeAddModal = ({ isOpen, closeModal, onClick, pendingApiCall, errors, setErrors }) => {

    const isFirstRender = useFirstRender()
    const [newCheque, setNewCheque] = useState({
        owner: "",
        deadline: "",
        currency: null,
        serialNumber: "",
        bank: "",
        branch: ""
    })

    const [customerPage, setCustomerPage] = useState({
        content: []
    });
    const [customerQuery, setCustomerQuery] = useState('')
    const [searchTimerCustomer, setSearchTimerCustomer] = useState();
    const pendingApiCallCustomer = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)
    const [customer, setCustomer] = useState()
    const searchingCustomer = async (params) => {
        if (searchTimerCustomer) clearTimeout(searchTimerCustomer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimerCustomer(timer);
    }
    const onClickLoadMoreCustomer = () => {
        if (!customerPage.last) {
            loadCustomers({ search: customerQuery, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }
    const loadCustomers = (params) => {
        !pendingApiCallCustomer &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }
    useEffect(() => {
        !isFirstRender && searchingCustomer({ search: customerQuery })
    }, [customerQuery])

    useEffect(() => {
        loadCustomers({ size: 20 })
    }, [])

    useEffect(() => {
        setNewCheque(prevState => ({ ...prevState, owner: customer ? customer.name : "" }))
    }, [customer])

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, owner: undefined }))
    }, [customer])


    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                >
                                    Yeni Çek
                                </Dialog.Title>
                                <CustomerPicker
                                    label='Müşteri'
                                    pendingApiCall={pendingApiCallCustomer}
                                    state={customer}
                                    setState={(value) => setCustomer(value)}
                                    query={customerQuery}
                                    setQuery={setCustomerQuery}
                                    //error={errors.customerId}
                                    page={customerPage}
                                    setErrors={() => setErrors(prevState => ({ ...prevState, customerId: undefined }))}
                                    onClickClear={() => setCustomer()}
                                    onClickLoadMore={() => onClickLoadMoreCustomer()}
                                />
                                <Input
                                    className='mb-3'
                                    name='owner'
                                    label='Çek Sahibi'
                                    type='text'
                                    placeholder='Çek sahibini girin...'
                                    value={newCheque.owner}
                                    error={errors?.owner}
                                    onChange={e => onChange(e, setNewCheque, setErrors)}
                                />
                                <CurrencyPicker
                                    label="Kur"
                                    value={newCheque.currency}
                                    onChange={(currency) => {
                                        setNewCheque(prevState => ({ ...prevState, currency }))
                                        setErrors(prevState => ({ ...prevState, currency: undefined }))
                                    }}
                                    text={(newCheque.currency) || 'Kur seçin'}
                                    items={CURRENCIES}
                                    error={errors?.currency}
                                />
                                <Input
                                    className='mb-3'
                                    name='amount'
                                    label='Tutar'
                                    type='number'
                                    value={newCheque.amount}
                                    error={errors?.amount}
                                    placeholder='Tutar girin...'
                                    onChange={e => onChange(e, setNewCheque, setErrors)}
                                />
                                <Input
                                    className='mb-3'
                                    name='deadline'
                                    label='Son Tarih'
                                    type='date'
                                    value={newCheque.deadline}
                                    error={errors?.deadline}
                                    onChange={e => onChange(e, setNewCheque, setErrors)}
                                />
                                <Input
                                    className='mb-3'
                                    name='serialNumber'
                                    label='Çek Numarası'
                                    type='text'
                                    value={newCheque.serialNumber}
                                    error={errors?.serialNumber}
                                    placeholder='Çek numarası girin...'
                                    onChange={e => onChange(e, setNewCheque, setErrors)}
                                />
                                <Input
                                    className='mb-3'
                                    name='bank'
                                    label='Banka'
                                    type='text'
                                    value={newCheque.bank}
                                    error={errors?.bank}
                                    placeholder='Banka adı girin...'
                                    onChange={e => onChange(e, setNewCheque, setErrors)}
                                />
                                <Input
                                    className='mb-3'
                                    name='branch'
                                    label='Şube'
                                    type='text'
                                    value={newCheque.branch}
                                    error={errors?.branch}
                                    placeholder='Şube adı girin...'
                                    onChange={e => onChange(e, setNewCheque, setErrors)}
                                />


                                <div className="mt-4 flex justify-between">
                                    <button
                                        type="button"
                                        className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-emerald-100 px-4 py-2 text-sm font-medium text-emerald-900 hover:bg-emerald-200"
                                        onClick={() => onClick(newCheque)}
                                        disabled={pendingApiCall}
                                    >
                                        Kaydet
                                        {pendingApiCall && <Spinner />}
                                    </button>
                                    <button
                                        type="button"
                                        className="outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                        onClick={closeModal}
                                    >
                                        İptal
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default ChequeAddModal